import PropTypes from 'prop-types'
import { useCallback, useEffect, useState } from 'react'
import { formatearFecha } from '../../helpers/helper'
import createValidador from '../../hooks/createValidador'
import { adjuntoBuilder } from '../../reutilizables/upload/adjuntoBuilder'

import * as archivoAdjuntoService from '../../servicios/archivoAdjuntoService'
import { insertarMail } from '../../servicios/mailsServices'
import * as mensajesService from '../../servicios/mensajesService'
import { Adjuntos } from './Adjuntos'
import styles from './Mensajeria.module.css'
import { Responder } from './Responder'
import { Respuesta } from './Respuesta'

const LENGTH_RESPUESTA = 150

const Mensajeria = ({
  idPublicacion,
  mensajes,
  setMensajes,
  vendedorNombre,
  obtenerClaseAlineado
}) => {
  const [texto, setTexto] = useState({})
  const [errores, setErrores] = useState({})
  const [adjuntoPendiente, setAdjuntoPendiente] = useState()
  const [adjunto, setAdjunto] = useState(null)

  const usuario = parseInt(localStorage.getItem('idUsuario'))

  const { Validador } = createValidador()

  const esquema = {
    texto: Validador.Kernel.string()
      .trim()
      .required()
      .max(LENGTH_RESPUESTA)
      .label('Mensaje')
      .error((errors) => {
        return Validador.mensaje(errors)
      })
  }

  const handleChange = (e, idMensaje) => {
    const value = e.target.value
    setTexto((prev) => ({ ...prev, [idMensaje]: value }))
    valido(value)
  }

  const valido = (value) => {
    const error = Validador.validarDato(esquema, { texto: value }, 'texto')
    setErrores(error ?? {})
    return !error
  }

  const agregarRespuesta = (mensajes, padreId, nuevaRespuesta) => {
    let encontrado = false

    const recorrer = (lista) => {
      return lista.map((m) => {
        // Si ya lo encontramos, no seguimos modificando nada
        if (encontrado) return m

        if (m.idMensaje === padreId) {
          encontrado = true

          const respuestasActuales = Array.isArray(m.respuestas) ? m.respuestas : []

          return {
            ...m,
            respuestas: [
              nuevaRespuesta,
              ...respuestasActuales.filter((r) => r.idMensaje !== nuevaRespuesta.idMensaje)
            ]
          }
        }

        if (Array.isArray(m.respuestas) && m.respuestas.length > 0) {
          return {
            ...m,
            respuestas: recorrer(m.respuestas)
          }
        }

        return m
      })
    }

    return recorrer(mensajes)
  }

  const submitRespuesta = async (idRespuesta, value, padre) => {
    if (!padre) {
      return
    }

    const idUsuario = usuario
    const idUsuarioChat = padre.idVendedor !== idUsuario ? padre.idVendedor : padre.idComprador

    const mensajeRes = {
      idMensajePadre: idRespuesta,
      idPublicacion,
      idPedidoItem: padre.idPedidoItem,
      idPresupuesto: padre.idPresupuesto,
      idUsuarioChat: idUsuarioChat,
      idComprador: padre.idComprador,
      idVendedor: padre.idVendedor,
      texto: value,
      privado: false,
      IdsAdjuntosList: adjuntoPendiente?.[idRespuesta]?.map((adjunto) => adjunto.idAdjunto) ?? null
    }

    const mail = {
      idTo: idUsuarioChat.toString() ?? '',
      idTipo: 1,
      param2: 'en la publicación',
      param3: idUsuario !== null ? idUsuario.toString() : ''
    }
    try {
      await mensajesService.insertar(mensajeRes)
      await insertarMail(mail)

      setMensajes(
        agregarRespuesta(mensajes, idRespuesta, {
          ...mensajeRes,
          vendedor: padre.vendedor,
          comprador: padre.comprador,
          idMensaje: Date.now(),
          fechaEscrito: new Date().toISOString()
        })
      )

      setTexto((prev) => ({ ...prev, [`mensaje-${idRespuesta}`]: '' }))
      setAdjuntoPendiente((prev) => {
        const updated = { ...prev }
        delete updated[idRespuesta]
        return updated
      })
    } catch {
      setMensajes(mensajes)
    }
  }

  const manejarAdjunto = useCallback(async (data, setAdjunto, idMensaje) => {
    const { dataAdjunto, adjunto } = data
    const previewAdjunto = await adjuntoBuilder(dataAdjunto, adjunto, adjunto.archivo, {
      preview: true
    })

    setAdjunto((prev) => {
      const nuevosAdjuntos = prev?.[idMensaje] || []

      const id = adjunto.idAdjunto || data.idAdjunto
      const existe = nuevosAdjuntos.some((a) => a.idAdjunto === id)

      if (existe) return prev

      return {
        ...prev,
        [idMensaje]: [...nuevosAdjuntos, { ...previewAdjunto, idAdjunto: id }]
      }
    })
  }, [])

  const fetchAdjunto = async (id, idMensaje) => {
    const { data } = await archivoAdjuntoService.buscarAdjuntosPorId(id)
    await manejarAdjunto(data, setAdjunto, idMensaje)
  }

  useEffect(() => {
    mensajes.forEach((mensaje) => {
      if (mensaje.idsAdjuntos) {
        const ids = mensaje.idsAdjuntos.split(',')

        ids.forEach((id) => {
          fetchAdjunto(id, mensaje.idMensaje)
        })
      }
    })
  }, [mensajes])

  return mensajes.length > 0 ? (
    mensajes.map((mensaje) => (
      <div key={mensaje.idMensaje}>
        <div className={`align-items-center ${obtenerClaseAlineado(mensaje.idUsuarioChat)}`}>
          <p className="text-left ml-3 mt-3 mb-1">
            {mensaje.texto}
            <br />
          </p>
          <Adjuntos adjunto={adjunto ? adjunto[mensaje.idMensaje] : null} />
          <span className={styles.usuarioMensaje}>
            De:{' '}
            {mensaje.idUsuarioChat !== mensaje.idVendedor
              ? vendedorNombre || mensaje.vendedor
              : mensaje.comprador}
          </span>
          <span className={styles.fechaMensaje}>
            {formatearFecha(mensaje.fechaEscrito, 'FH', 'hs')}
          </span>
        </div>
        <Responder
          idComprador={mensaje.idComprador}
          idVendedor={mensaje.idVendedor}
          idUsuarioChat={mensaje.idUsuarioChat}
          idMensaje={mensaje.idMensaje}
          usuario={usuario}
          handleChange={handleChange}
          texto={texto}
          errores={errores}
          submitRespuesta={submitRespuesta}
          valido={valido}
          mensaje={mensaje}
          idPublicacion={idPublicacion}
          adjuntoPendiente={adjuntoPendiente}
          setAdjuntoPendiente={setAdjuntoPendiente}
          manejarAdjunto={manejarAdjunto}
        />
        {mensaje.respuestas && mensaje.respuestas.length > 0 && (
          <Respuesta
            respuesta={mensaje.respuestas}
            usuario={usuario}
            mensaje={mensaje}
            texto={texto}
            errores={errores}
            handleChange={handleChange}
            submitRespuesta={submitRespuesta}
            valido={valido}
            idPublicacion={idPublicacion}
            adjuntoPendiente={adjuntoPendiente}
            setAdjuntoPendiente={setAdjuntoPendiente}
            manejarAdjunto={manejarAdjunto}
            obtenerClaseAlineado={obtenerClaseAlineado}
            vendedorNombre={vendedorNombre || mensaje.vendedor}
          />
        )}

        <hr className="my-3" />
      </div>
    ))
  ) : (
    <p>No hay mensajes</p>
  )
}

Mensajeria.propTypes = {
  mensajes: PropTypes.array.isRequired,
  setMensajes: PropTypes.func.isRequired,
  idPublicacion: PropTypes.number.isRequired,
  esVendedor: PropTypes.bool,
  idVendedor: PropTypes.number,
  vendedorNombre: PropTypes.string,
  obtenerClaseAlineado: PropTypes.func.isRequired
}

export default Mensajeria
